import { render } from "./ActivateAccount.vue?vue&type=template&id=e5edcffc&scoped=true&ts=true"
import script from "./ActivateAccount.vue?vue&type=script&lang=ts"
export * from "./ActivateAccount.vue?vue&type=script&lang=ts"

import "./ActivateAccount.vue?vue&type=style&index=0&id=e5edcffc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5edcffc"]])

export default __exports__